import { OLDEST_TIME } from '@casops/config/time';
import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import { RegisteredAssetDetailModel } from '@casops/store/apis/registeredAssetsApi';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

interface UseAssetOverviewStatusProps {
  asset?: RegisteredAssetDetailModel;
}

export interface AssetOverviewErrors {
  activeFaults: boolean;
  reporting: boolean;
  config: boolean; // Software Status (Software/config status, Geofence status, name mismatch status)
}

export const useAssetOverviewErrors = ({
  asset,
}: UseAssetOverviewStatusProps): AssetOverviewErrors => {
  const { parseFromIso } = useLocaleFormatter();

  return useMemo(() => {
    if (asset) {
      const timeReported = parseFromIso(asset.tsRp ?? OLDEST_TIME);
      const timeConnected = parseFromIso(asset.tsRx ?? OLDEST_TIME);

      const sevenDaysAgo = DateTime.now().minus({ days: 7 });

      return {
        activeFaults: !asset.stH,
        reporting: timeReported < sevenDaysAgo || timeConnected < sevenDaysAgo,
        config: !asset.stC || asset.siteGeoVer !== asset.geoVer || !asset.stN,
      };
    }

    return {
      activeFaults: false,
      reporting: false,
      config: false,
    };
  }, [asset, parseFromIso]);
};
